export function getValueEnumObject<T>(object: Object, key: string, _default: string = ""): T {
    key = key.replace(/[, ]+/g, " ").trim();
    return (Object(object)[key] || _default) as T;
}
